<div class="display-flex flex-column">
  <div mat-dialog-title class="display-flex justify-content-space-between">
    <div class="display-flex align-items-center grid-gap-4">
      <h4 class="flex-1">{{ header }}</h4>
      <div [matMenuTriggerFor]="categoriesMenu" class="send-notifications">
        <app-icon
          [iconWidth]="16"
          [svg]="EIcon.BELL"
          [iconColor]="EColorPalette.cGray5"
          *ngIf="!form.get('doNotSendNotifications')?.value"></app-icon>
        <app-icon
          [iconWidth]="16"
          [svg]="EIcon.BELL_CROSSED"
          [iconColor]="EColorPalette.cGray5"
          *ngIf="form.get('doNotSendNotifications')?.value"></app-icon>
      </div>
    </div>
    <mat-menu #categoriesMenu="matMenu" class="menu-with-backdrop">
      <div mat-menu-item (click)="toggleNotification(false)" class="notification-menu-item">
        Enable notifications
        <app-icon
          *ngIf="!form.get('doNotSendNotifications')?.value"
          [svg]="EIcon.CHECK_YES"
          [iconWidth]="18"></app-icon>
      </div>
      <div mat-menu-item (click)="toggleNotification(true)" class="notification-menu-item">
        Disable all notifications
        <app-icon *ngIf="form.get('doNotSendNotifications')?.value" [svg]="EIcon.CHECK_YES" [iconWidth]="18"></app-icon>
      </div>
    </mat-menu>
    <ng-container [ngTemplateOutlet]="userType"></ng-container>
  </div>

  <mat-dialog-content>
    <form [formGroup]="form">
      <ng-template #userType>
        <div class="flex-30" *ngIf="form">
          <app-radio-button-dropdown
            class="flex-grow-1"
            [containerCss]="'w-100'"
            [items]="userTypeListAllowed"
            [disabled]="userTypeListAllowed?.length === 1"
            [labelRequired]="true"
            [allowClear]="false"
            [allowSearch]="false"
            [autoSortList]="false"
            [showValidationError]="false"
            [formControl]="userGroupType"
            [displaySkeleton]="isLoading"
            [optionCss]="'inspection-format-option'"
            [placeholderCss]="'width-183'"
            attrAppendTo="body"></app-radio-button-dropdown>
        </div>
      </ng-template>
      <ng-container *ngIf="form">
        <div class="display-flex flex-column grid-gap-16">
          <div class="display-flex grid-gap-16" *ngIf="userGroupType?.value === UserType.Resident">
            <app-radio-button-dropdown
              class="w-50"
              [items]="properties$ | async"
              [allowSearch]="(properties$ | async)?.length > 7"
              [attrDisable]="!(properties$ | async)?.length"
              [label]="'Property'"
              [formControl]="propertyId"
              [displaySkeleton]="isLoading"
              [allowClear]="true"
              [listLoading]="selectPropertiesLoading$ | async"
              [attrPlaceholder]="(selectPropertiesLoading$ | async) ? 'Loading properties…' : 'Select property'"
              [labelRequired]="true"
              [showValidationError]="isSubmitted"
              attrAppendTo="body"></app-radio-button-dropdown>
            <app-radio-button-dropdown
              class="w-50"
              [items]="units$ | async"
              [allowSearch]="(units$ | async)?.length > 7"
              [attrDisable]="!(units$ | async)?.length || !propertyId?.value"
              [label]="'Unit'"
              [formControl]="unitId"
              [displaySkeleton]="isLoading"
              [allowClear]="false"
              [labelRequired]="true"
              [listLoading]="unitListLoading$ | async"
              [attrPlaceholder]="(unitListLoading$ | async) ? 'Loading units…' : 'Select unit'"
              [showValidationError]="isSubmitted"
              attrAppendTo="body"></app-radio-button-dropdown>
          </div>
          <div class="display-flex grid-gap-16">
            <app-input
              class="w-50"
              [attrLabel]="'First name'"
              [contentCss]="'display-flex flex-column fill'"
              [formControl]="firstName"
              [displaySkeleton]="isLoading"
              [attrPlaceholder]="!firstName.value ? 'Enter first name' : ''"
              [labelRequired]="true"
              [showValidationError]="isSubmitted"></app-input>
            <app-input
              class="w-50"
              [attrLabel]="'Last name'"
              [contentCss]="'display-flex flex-column fill'"
              [formControl]="lastName"
              [displaySkeleton]="isLoading"
              [attrPlaceholder]="!lastName.value ? 'Enter last name' : ''"
              [labelRequired]="true"
              [showValidationError]="isSubmitted"></app-input>
          </div>

          <div class="display-flex flex-column grid-gap-4">
            <div>
              <div class="display-flex grid-gap-16">
                <div class="w-50">
                  <app-input
                    [attrLabel]="'Email'"
                    [contentCss]="'display-flex flex-column fill'"
                    [formControl]="email"
                    [displaySkeleton]="isLoading"
                    [attrPlaceholder]="!email.value ? 'Enter email' : ''"
                    [showValidationError]="isSubmitted"
                    (blurEvent)="onEmailBlur()"></app-input>
                  <ng-container *ngIf="isSubmitted">
                    <ng-container *ngIf="emailAddedAsIdentity.value && !email.value; else emailDefaultErrors">
                      <app-input-error
                        [visible]="true"
                        [errors]="{
                          emailAddedAsIdentity: true
                        }"></app-input-error>
                    </ng-container>
                    <ng-template #emailDefaultErrors>
                      <app-input-error class="w-50" [visible]="true" [errors]="form.errors"></app-input-error>
                    </ng-template>
                  </ng-container>
                </div>

                <app-phone-number-input
                  class="w-50"
                  [attrLabel]="'Phone Number'"
                  [defaultCode]="defaultCode"
                  [showValidationError]="isSubmitted"
                  [formControl]="phoneNumber"
                  [displaySkeleton]="isLoading"
                  [phoneNumberAsIdentity]="phoneNumberAddedAsIdentity.value"
                  [updatePhoneInputValidation]="updatePhoneInputValidation"
                  [editMode]="editMode"
                  (phoneNumberInvalid)="phoneNumberInvalid = $event"
                  [numberRequired]="isSubmitted && !phoneNumber.value && phoneNumberAddedAsIdentity.value"
                  (inputReady)="phoneInputReady()"
                  (blurEvent)="onPhoneBlur()"></app-phone-number-input>
              </div>
            </div>
            <div class="display-flex grid-gap-16">
              <div class="w-50 display-flex align-items-center grid-gap-6">
                <mat-checkbox
                  class="mat-checkbox-small"
                  *ngIf="!isLoading"
                  color="primary"
                  [formControl]="emailAddedAsIdentity">
                  <span class="warning-message">Register email as user login & send an invite</span>
                </mat-checkbox>
                <ng-container>
                  <div class="skeleton-loader" *ngIf="isLoading"></div>
                </ng-container>
              </div>
              <div class="w-50 display-flex align-items-center grid-gap-6">
                <mat-checkbox
                  class="mat-checkbox-small"
                  *ngIf="!isLoading"
                  color="primary"
                  [formControl]="phoneNumberAddedAsIdentity">
                  <span class="warning-message">Register phone number as user login</span>
                </mat-checkbox>
                <ng-container>
                  <div class="skeleton-loader" *ngIf="isLoading"></div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="display-flex grid-gap-16" *ngIf="domainExist$ | async">
            <app-input
              class="w-100"
              [attrLabel]="'Issuer Assignee Id'"
              [contentCss]="'display-flex flex-column fill'"
              [formControl]="federatedIssuerAssigneeId"
              [displaySkeleton]="isLoading"
              [labelRequired]="true"
              [showValidationError]="isSubmitted"></app-input>
          </div>

          <div class="display-flex grid-gap-16">
            <app-radio-button-dropdown
              class="w-50"
              [containerCss]="'user-preview-role'"
              [items]="userRoles"
              [label]="'Role'"
              [containerWidthCss]="'user-preview-role'"
              [formControl]="roleId"
              [displaySkeleton]="isLoading"
              [allowClear]="false"
              [attrPlaceholder]="'Select role'"
              [labelRequired]="true"
              [showValidationError]="isSubmitted"
              attrAppendTo="body"></app-radio-button-dropdown>

            <app-radio-button-dropdown
              class="w-50"
              [label]="'Native language'"
              [attrAppendTo]="'body'"
              [allowClear]="false"
              [allowSearch]="false"
              [items]="nativeLanguages"
              [showValidationError]="isSubmitted"
              [formControl]="nativeLanguage"
              [displaySkeleton]="isLoading"></app-radio-button-dropdown>
          </div>
          <div class="display-flex grid-gap-16">
            <app-select-tree
              *ngIf="userGroupType?.value !== UserType.Resident"
              class="w-100"
              [label]="'Portfolio/Properties'"
              (selectedRoots)="selectedRootsChange($event)"
              [nodes]="root"
              [isSuperUser]="isSuperUser"
              [selectedNodes]="propertiesToSelect"
              [warningMessage]="warningMessage"
              [displaySkeleton]="isLoading"></app-select-tree>
          </div>

          <div class="display-flex grid-gap-16">
            <app-radio-button-dropdown
              class="w-100"
              *ngIf="userGroupType?.value === UserType.Contractor"
              [containerCss]="'user-preview-role'"
              [autoSortList]="false"
              [items]="companyRadioList"
              [label]="'Company'"
              [containerWidthCss]="'user-preview-role'"
              [formControl]="companyId"
              [displaySkeleton]="isLoading"
              [allowClear]="true"
              [attrPlaceholder]="'Select company'"
              [labelRequired]="true"
              [listLoading]="companyListLoading$ | async"
              [showValidationError]="isSubmitted"
              [allowAddNew]="true"
              [addNewLabel]="'+ Add new vendor'"
              (addNewClicked)="addNewVendor()"
              attrAppendTo="body"></app-radio-button-dropdown>
          </div>
        </div>
      </ng-container>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="display-flex grid-gap-8 justify-content-end w-100">
      <button mat-stroked-button color="warn" class="modal-button" [disabled]="isLoading" (click)="close()">
        Cancel
      </button>
      <button
        mat-raised-button
        color="primary"
        class="modal-button"
        [disabled]="(inProgress$ | async) || isLoading"
        (click)="save()">
        <div class="display-flex align-items-center grid-gap-4">
          <ng-container *ngIf="userGroupType.value === UserType.Resident; else saveBtnTxt">
            {{ saveResidentButtonText }}
          </ng-container>
          <ng-template #saveBtnTxt>
            {{ !emailAddedAsIdentity?.value && !editMode ? 'Create user' : saveButtonText }}
          </ng-template>
          <mat-spinner *ngIf="inProgress$ | async" color="accent" diameter="20"></mat-spinner>
        </div>
      </button>
    </div>
  </mat-dialog-actions>
</div>
